import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
    MatToolbarModule,
    MatButtonModule,
    MAT_DIALOG_DEFAULT_OPTIONS,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule } from '@angular/material';

import { DialogModule } from './dialog.module';

import { RouterModule } from '@angular/router';

import { HeaderModule } from './header.module';
import { LoginComponent } from '../auth/login/login.component';
import { LogOutComponent } from '../auth/logout/logout.component';
import { RegisterComponent } from '../auth/register/register.component';
import { NewPasswordComponent } from '../auth/request-password/request.password.component';

const imports = [
    MatToolbarModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    CommonModule,
    FormsModule,
    DialogModule,
    RouterModule,
    HeaderModule,
];

const exps = [
    LoginComponent,
    LogOutComponent,
    RegisterComponent,
    NewPasswordComponent
];

const declarations = [
    LoginComponent,
    LogOutComponent,
    RegisterComponent,
    NewPasswordComponent
];

@NgModule({
    imports: [...imports],
    exports: [...exps],
    declarations: [...declarations]
})
export class LoginModule { }
